import {HAL, RestClient} from '../../rest-client';

export class OAuth2Service {
  private client: RestClient;

  constructor(client: RestClient) {
    this.client = client;
  }

  authenticate = (url?: string, request?: OAuth2AuthCodeRequest) => {
    return this.client.fetchJSONBody<OAuth2AuthenticateResponse>(
      'POST',
      url,
      request,
    );
  };

  refresh = async (url?: string, request?: OAuth2AuthRefreshRequest) => {
    const response = await this.client.fetch({
      method: 'POST',
      url,
      body: JSON.stringify(request),
      isAuthRefresh: true,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    return await this.client.decodeJSON<OAuth2AuthenticateResponse>(response);
  };

  createLoginHint = (url: string, request: unknown) => {
    return this.client.fetchJSON('POST', url, request);
  };
}

export interface OAuth2AuthCodeRequest {
  grant_type: 'code';
  client_id: string;
  code: string;
  code_verifier?: string;
}

export interface OAuth2AuthRefreshRequest {
  grant_type: 'refresh_token';
  client_id: string;
  refresh_token?: string;
}

export interface OAuth2AuthenticateResponse extends HAL {
  access_token: string;
  refresh_token: string;
  refresh_token_expires_in: number;
}
